import { render, staticRenderFns } from "./FamousCommentItemSecond.vue?vue&type=template&id=4c0b5f04&"
import script from "./FamousCommentItemSecond.vue?vue&type=script&lang=js&"
export * from "./FamousCommentItemSecond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports